import { render, staticRenderFns } from "./waveCharts.vue?vue&type=template&id=e18b8660&scoped=true"
import script from "./waveCharts.vue?vue&type=script&lang=js"
export * from "./waveCharts.vue?vue&type=script&lang=js"
import style0 from "./waveCharts.vue?vue&type=style&index=0&id=e18b8660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18b8660",
  null
  
)

export default component.exports